/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} User_Detail_ExpiresInputs */



/**
* | output |
* | --- |
* | "until {date}" |
*
* @param {User_Detail_ExpiresInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_expires = /** @type {((inputs: User_Detail_ExpiresInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_ExpiresInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`jusqu'à ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`hasta ${i?.date}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`até ${i?.date}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`fino a ${i?.date}`)
	return /** @type {LocalizedString} */ (`until ${i?.date}`)
});